import * as yup from 'yup';
import { getUniqueSeparatedStringsFromTextField } from '../utils';
import BulkAddToMemberStrings from './BulkAddToMemberStrings';
var collectAndAddEmails = BulkAddToMemberStrings.collectAndAddEmails;
export var getInvalidFormatEmails = function (texts) {
    var emailValidationSchema = yup.object().shape({
        emails: yup.array().of(yup.string().email(function (_a) {
            var value = _a.value;
            return value;
        })),
    });
    try {
        emailValidationSchema.validateSync({ emails: texts }, { abortEarly: false });
    }
    catch (err) {
        var invalidEmails = err.errors;
        return invalidEmails;
    }
    return [];
};
var formatInvalidEmailsErrorMessage = function (invalidEmails) {
    var numberOfInvalidEmails = invalidEmails.length;
    var formatInvalidEmails = invalidEmails.map(function (text) { return "\"" + text + "\""; });
    var joinInvalidEmails = formatInvalidEmails.join(', ');
    var errorMessage = numberOfInvalidEmails > 1
        ? collectAndAddEmails.notValidEmailFormat.multipleFail(joinInvalidEmails)
        : collectAndAddEmails.notValidEmailFormat.singleFail(joinInvalidEmails);
    return errorMessage;
};
var formatNumberOfEmailsExceededErrorMessage = function (totalEmails, limit) {
    var numOfEmailToRemove = totalEmails - limit;
    var errorMessage = numOfEmailToRemove > 1
        ? collectAndAddEmails.exceedEmailLimit.multipleFail(limit, numOfEmailToRemove)
        : collectAndAddEmails.exceedEmailLimit.singleFail(limit, numOfEmailToRemove);
    return errorMessage;
};
export var validateTextField = function (textField, emailLimit) {
    // text field must not be empty
    if (!textField) {
        return {
            isValid: false,
            error: collectAndAddEmails.fieldIsRequired,
        };
    }
    var textsArray = getUniqueSeparatedStringsFromTextField(textField);
    // validate email format
    var invalidEmails = getInvalidFormatEmails(textsArray);
    if (invalidEmails === null || invalidEmails === void 0 ? void 0 : invalidEmails.length) {
        return {
            isValid: false,
            error: formatInvalidEmailsErrorMessage(invalidEmails),
        };
    }
    // validate number of emails
    if (textsArray.length > emailLimit) {
        return {
            isValid: false,
            error: formatNumberOfEmailsExceededErrorMessage(textsArray.length, emailLimit),
        };
    }
    return { isValid: true };
};
